

// import axiosClient from '../axiosClient';

// // ── Core blob fetcher ─────────────────────────────────────────────────────
// // Uses raw fetch to avoid axiosClient JSON-parsing binary data.
// // Sends auth cookie automatically via credentials: 'include'.
// const fetchBlob = async (url) => {
//     console.log('📥 fetchBlob →', url);

//     const response = await fetch(url, {
//         method:      'GET',
//         credentials: 'include',
//     });

//     console.log('📥 Response status:', response.status);
//     console.log('📥 Content-Type:', response.headers.get('Content-Type'));
//     console.log('📥 Content-Length:', response.headers.get('Content-Length'));

//     if (!response.ok) {
//         let msg = `HTTP ${response.status}`;
//         try {
//             const text = await response.text();
//             if (text) msg = text.slice(0, 300);
//         } catch { /* ignore */ }
//         throw new Error(msg);
//     }

//     const contentType = response.headers.get('Content-Type') || '';

//     // If server returned HTML/JSON instead of PDF, surface the error
//     if (
//         contentType.includes('text/html') ||
//         contentType.includes('application/json')
//     ) {
//         const text = await response.text();
//         console.error('❌ Expected PDF, got:', contentType);
//         console.error('❌ Body preview:', text.slice(0, 300));
//         throw new Error('Server returned an error page instead of a PDF. Check console.');
//     }

//     const blob = await response.blob();
//     console.log('✅ Blob received | size:', blob.size, '| type:', blob.type);

//     if (blob.size === 0) {
//         throw new Error('Downloaded file is empty (0 bytes)');
//     }

//     return blob;
// };

// // ── Trigger browser download ──────────────────────────────────────────────
// export const triggerDownload = (blob, filename) => {
//     const url = URL.createObjectURL(blob);
//     const a   = document.createElement('a');
//     a.href     = url;
//     a.download = filename;
//     document.body.appendChild(a);
//     a.click();
//     a.remove();
//     setTimeout(() => URL.revokeObjectURL(url), 5000);
// };

// export const downloadCenterApi = {

//     // ── Suggestions ───────────────────────────────────────────────────────
//     getItemSuggestions: async (searchTerm) => {
//         try {
//             return await axiosClient.get(
//                 `/download-center/suggestions?search=${encodeURIComponent(searchTerm)}`
//             ) || [];
//         } catch (error) {
//             console.error('Error fetching suggestions:', error);
//             throw error;
//         }
//     },

//     getPackSizes: async (itemCode) => {
//         try {
//             return await axiosClient.get(
//                 `/download-center/pack-sizes?itemCode=${encodeURIComponent(itemCode)}`
//             ) || [];
//         } catch (error) {
//             console.error('Error fetching pack sizes:', error);
//             throw error;
//         }
//     },

//     getBatchNums: async (catSizeMain) => {
//         try {
//             return await axiosClient.get(
//                 `/download-center/batch-nums?catSizeMain=${encodeURIComponent(catSizeMain)}`
//             ) || [];
//         } catch (error) {
//             console.error('Error fetching batch numbers:', error);
//             throw error;
//         }
//     },

//     // ── Invoice ───────────────────────────────────────────────────────────
//     checkInvoice: async (invoiceNo) => {
//         try {
//             return await axiosClient.get(
//                 `/invoice/check-pdf/${encodeURIComponent(invoiceNo)}`
//             );
//         } catch (error) {
//             console.error('Error checking invoice:', error);
//             throw error;
//         }
//     },

//     downloadInvoice: async (invoiceNo) => {
//         return fetchBlob(`/api/invoice/download-pdf/${encodeURIComponent(invoiceNo)}`);
//     },

//     // ── 3A COA ────────────────────────────────────────────────────────────
//     check3ACOA: async (itemCode, batchNum) => {
//         try {
//             return await axiosClient.get(
//                 `/coa/exists-energy/${encodeURIComponent(itemCode)}/${encodeURIComponent(batchNum)}`
//             );
//         } catch (error) {
//             console.error('Error checking 3A COA:', error);
//             throw error;
//         }
//     },

//     download3ACOA: async (itemCode, batchNum) => {
//         return fetchBlob(
//             `/api/coa/download-energy/${encodeURIComponent(itemCode)}/${encodeURIComponent(batchNum)}`
//         );
//     },

//     // ── Density COA ───────────────────────────────────────────────────────
//     checkDensityCOA: async (itemCode, batchNum) => {
//         try {
//             return await axiosClient.get(
//                 `/density-coa/search?itemCode=${encodeURIComponent(itemCode)}&batchNumber=${encodeURIComponent(batchNum)}`
//             );
//         } catch (error) {
//             console.error('Error checking Density COA:', error);
//             throw error;
//         }
//     },

//     downloadDensityCOA: async (itemCode, batchNum) => {
//         return fetchBlob(
//             `/api/density-coa/download-by-item/${encodeURIComponent(itemCode)}/${encodeURIComponent(batchNum)}`
//         );
//     },
// };

import axiosClient from '../axiosClient';

// ── Spring Boot direct URL — bypasses React dev server proxy ──────────────
const SPRING_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

// ── Core blob fetcher ─────────────────────────────────────────────────────
const fetchBlob = async (path) => {
    const fullUrl = `${SPRING_BASE}${path}`;
    console.log('📥 fetchBlob →', fullUrl);

    const response = await fetch(fullUrl, {
        method:      'GET',
        credentials: 'include',
    });

    console.log('📥 Response status:', response.status);
    console.log('📥 Content-Type:', response.headers.get('Content-Type'));
    console.log('📥 Content-Length:', response.headers.get('Content-Length'));

    if (!response.ok) {
        let msg = `HTTP ${response.status}`;
        try {
            const text = await response.text();
            if (text) msg = text.slice(0, 300);
        } catch { /* ignore */ }
        throw new Error(msg);
    }

    const contentType = response.headers.get('Content-Type') || '';

    if (
        contentType.includes('text/html') ||
        contentType.includes('application/json')
    ) {
        const text = await response.text();
        console.error('❌ Expected PDF, got:', contentType);
        console.error('❌ Body preview:', text.slice(0, 300));
        throw new Error('Server returned an error instead of a PDF. Check console.');
    }

    const blob = await response.blob();
    console.log('✅ Blob received | size:', blob.size, '| type:', blob.type);

    if (blob.size === 0) {
        throw new Error('Downloaded file is empty (0 bytes)');
    }

    return blob;
};

// ── Trigger browser download ──────────────────────────────────────────────
export const triggerDownload = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const a   = document.createElement('a');
    a.href     = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 5000);
};

export const downloadCenterApi = {

    // ── Suggestions ───────────────────────────────────────────────────────
    getItemSuggestions: async (searchTerm) => {
        try {
            return await axiosClient.get(
                `/download-center/suggestions?search=${encodeURIComponent(searchTerm)}`
            ) || [];
        } catch (error) {
            console.error('Error fetching suggestions:', error);
            throw error;
        }
    },

    getPackSizes: async (itemCode) => {
        try {
            return await axiosClient.get(
                `/download-center/pack-sizes?itemCode=${encodeURIComponent(itemCode)}`
            ) || [];
        } catch (error) {
            console.error('Error fetching pack sizes:', error);
            throw error;
        }
    },

    getBatchNums: async (catSizeMain) => {
        try {
            return await axiosClient.get(
                `/download-center/batch-nums?catSizeMain=${encodeURIComponent(catSizeMain)}`
            ) || [];
        } catch (error) {
            console.error('Error fetching batch numbers:', error);
            throw error;
        }
    },

    // ── Invoice ───────────────────────────────────────────────────────────
    checkInvoice: async (invoiceNo) => {
        try {
            return await axiosClient.get(
                `/invoice/check-pdf/${encodeURIComponent(invoiceNo)}`
            );
        } catch (error) {
            console.error('Error checking invoice:', error);
            throw error;
        }
    },

    downloadInvoice: async (invoiceNo) => {
        return fetchBlob(`/api/invoice/download-pdf/${encodeURIComponent(invoiceNo)}`);
    },

    // ── 3A COA ────────────────────────────────────────────────────────────
    check3ACOA: async (itemCode, batchNum) => {
        try {
            return await axiosClient.get(
                `/coa/exists-energy/${encodeURIComponent(itemCode)}/${encodeURIComponent(batchNum)}`
            );
        } catch (error) {
            console.error('Error checking 3A COA:', error);
            throw error;
        }
    },

    download3ACOA: async (itemCode, batchNum) => {
        return fetchBlob(
            `/api/coa/download-energy/${encodeURIComponent(itemCode)}/${encodeURIComponent(batchNum)}`
        );
    },

    // ── Density COA ───────────────────────────────────────────────────────
    checkDensityCOA: async (itemCode, batchNum) => {
        try {
            return await axiosClient.get(
                `/density-coa/search?itemCode=${encodeURIComponent(itemCode)}&batchNumber=${encodeURIComponent(batchNum)}`
            );
        } catch (error) {
            console.error('Error checking Density COA:', error);
            throw error;
        }
    },

    downloadDensityCOA: async (itemCode, batchNum) => {
        return fetchBlob(
            `/api/density-coa/download-by-item/${encodeURIComponent(itemCode)}/${encodeURIComponent(batchNum)}`
        );
    },
};